import React from 'react';
import { brainRotContent } from '../rich-content/brain-rot-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const BrainRotDetailPage = () => {
  return <AutomaticPageBuilder content={brainRotContent} />;
};

export default BrainRotDetailPage;
